import cx from 'classnames';
import { useMeQuery, UserRole } from 'legoland-sdk/dist/experimental';
import { useEffectiveLimitsQuery } from "../api/limitsApiHooks";
import { useProductLimitSchemas } from "../productsHooks";
import { useEffect, useState } from 'react';
import { Text } from 'tombac';
import { useUserDetails } from "../../users/UserDetailsProvider";
import "./LimitsSummary.css";
import { LimitSummaryList } from "./LimitSummaryList";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function LimitsSummary({
  className,
  headerClassName,
  product
}) {
  const me = useMeQuery().data.me;
  const schemas = useProductLimitSchemas({
    productId: product.id
  });
  const user = useUserDetails();
  const [limits, setLimits] = useState(null);
  const effectiveLimitsQuery = useEffectiveLimitsQuery({
    username: user.email,
    productId: product.id
  });
  const {
    limits: loadedLimits,
    sharedWith,
    usage: limitsUsage
  } = effectiveLimitsQuery.data?.result ?? {};
  useEffect(() => {
    let limits = null;
    if (loadedLimits && schemas) {
      limits = {};
      schemas.forEach(({
        customizable,
        name,
        type
      }) => {
        if (type !== 'BOOLEAN' && name in loadedLimits && customizable && loadedLimits[name] !== undefined && loadedLimits[name] !== null && (me.role !== UserRole.Admin || !sharedWith.find(i => i.names.includes(name)))) limits[name] = loadedLimits[name];
      });
    }
    setLimits(limits);
  }, [loadedLimits, me, schemas, sharedWith]);
  return schemas && schemas.length > 0 ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: cx('LimitsSummary__header', headerClassName),
      children: "Usage limits"
    }), /*#__PURE__*/_jsx("div", {
      className: cx('LimitsSummary', className),
      children: effectiveLimitsQuery.isLoading ? /*#__PURE__*/_jsx(Text, {
        variant: "secondary",
        children: "Loading..."
      }) : effectiveLimitsQuery.isError ? /*#__PURE__*/_jsx(Text, {
        variant: "danger",
        children: "Error: Could not load data."
      }) : /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx(LimitSummaryList, {
          $flex: "1",
          limits: limits,
          schemas: schemas,
          usages: limitsUsage
        })
      })
    })]
  }) : null;
}